import showSuccNotif from 'src/mixins/Notification'
import { eventBus } from './eventBus'

// const env_API =process.env.env_API

function open (wsObj) {
  // const wsUri = 'ws://120.55.86.150:8000/' + 'ws/drama/admin/'
  const wsUri = 'ws://localhost:8000/' + 'ws/drama/admin/'
  this.socket = new WebSocket(wsUri)// 这里面的this都指向vue
  this.socket.onerror = webSocketOnError
  this.socket.onmessage = onmessageWs
  this.socket.onclose = close
}

function webSocketOnError (e) {
  // showSuccNotif('WebSocket连接发生错误' + JSON.stringify(e))
  console.log('WebSocket连接发生错误' + JSON.stringify(e))
}

/**
 * 接收消息
 * @param e
 * @returns {any}
 */
function onmessageWs (e) {
  const data = JSON.parse(e.data)
  // // console.log(data)
  // if(data[0] === 'success') {
  //   // this.url = data.data['@microsoft.graph.downloadUrl']
  //   // this.close()
  // }
  console.log(data)
  eventBus.emit('onmessageWS',data)
  // window.dispatchEvent(new CustomEvent('onmessageWS', {
  //   detail: {
  //     data: e.data
  //   }
  // }))
}
// 关闭websiocket
function close () {
  console.log('连接已关闭...')
  // showSuccNotif('连接已关闭...')
}

/**
 * 发送消息
 * @param message
 */
function emit (message) {
  this.socket.send(JSON.stringify(message))
}

export default {open, close, emit, onmessageWs}

